import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["apiData", "params", "dispatch"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getApiDataRequest, getResultData, performApiRequest } from '../redux/apiData';
import hoistNonReactStatic from 'hoist-non-react-statics';

/**

  PLEASE SEE /redux/README.md FOR MORE INFORMATION ON THE REDUX SETUP AND LIBRARIES USED IN THIS APPLICATION.

*/

/**
 * Bind api data to component props and automatically triggers loading of data if it hasn't been loaded yet. The wrapped
 * component will get an ApiDataBinding added to each property key of the bindings param.
 * @param bindings - maps prop names to endpoint keys
 * @param [getParams] - optionally provide the params of the endpoint
 * @returns {Function} - Function to wrap your component
 * @example
  withApiData({
    wishList: 'getWishLists',
    settings: 'getSettings'
  }, (ownProps, state) => ({
    wishList: {
      projectSlug: ownProps.match.params.projectSlug,
      env: ownProps.match.params.env
    },
    settings: {
      projectSlug: ownProps.match.params.projectSlug,
      env: ownProps.match.params.env
    }
  }))
 */
export default function withApiData(bindings, getParams) {
  return function (WrappedComponent) {
    var WithApiData = /*#__PURE__*/function (_Component) {
      function WithApiData() {
        _classCallCheck(this, WithApiData);
        return _callSuper(this, WithApiData, arguments);
      }
      _inherits(WithApiData, _Component);
      return _createClass(WithApiData, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.fetchDataIfNeeded();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(oldProps) {
          var _this = this;
          // automatically re-fetch when a request gets invalidated
          var getRequest = function getRequest(props, propName) {
            return getApiDataRequest(props.apiData, bindings[propName], props.params[propName]);
          };
          var hasBeenInvalidated = function hasBeenInvalidated(oldRequest, newRequest) {
            return !!oldRequest && oldRequest.networkStatus === 'success' && !!newRequest && newRequest.networkStatus === 'ready';
          };
          Object.keys(bindings).forEach(function (propName) {
            if (hasBeenInvalidated(getRequest(oldProps, propName), getRequest(_this.props, propName))) {
              _this.props.dispatch(performApiRequest(bindings[propName], _this.props.params[propName]));
            }
          });
        }
      }, {
        key: "fetchDataIfNeeded",
        value: function fetchDataIfNeeded() {
          var _this$props = this.props,
            params = _this$props.params,
            dispatch = _this$props.dispatch;
          Object.keys(bindings).forEach(function (propName) {
            var endpointKey = bindings[propName];
            // performApiRequest will check if fetch is needed
            if (params && params.options) {
              dispatch(performApiRequest(endpointKey, params[propName], undefined, params.options));
            } else {
              dispatch(performApiRequest(endpointKey, params[propName]));
            }
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
            apiData = _this$props2.apiData,
            params = _this$props2.params,
            dispatch = _this$props2.dispatch,
            componentProps = _objectWithoutProperties(_this$props2, _excluded);
          var props = _objectSpread({}, componentProps);
          Object.keys(bindings).forEach(function (propName) {
            var endpointKey = bindings[propName];
            props[propName] = {
              data: getResultData(apiData, endpointKey, params[propName]),
              request: getApiDataRequest(apiData, endpointKey, params[propName]) || {
                networkStatus: 'ready',
                lastCall: 0
              }
            };
          });
          return __jsx(WrappedComponent, _extends({}, props, {
            "data-id": "services_withApiData_WrappedComponent"
          }));
        }
      }]);
    }(Component);
    _defineProperty(WithApiData, "displayName", "WithApiData(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));
    hoistNonReactStatic(WithApiData, WrappedComponent); // move static methods to wrapper

    return connect(function (state, ownProps) {
      return {
        params: typeof getParams === 'function' ? getParams(ownProps, state) : {},
        apiData: state.apiData
      };
    })(WithApiData);
  };
}